import ContactModal from './ContactModal'
export { ContactModal }
export default ContactModal
